import { createSelector } from "reselect";

const getStore = state => state.menaBanner || {};

export const isMenaBannerVisible = createSelector(
  getStore,
  store => store.visible || false
);
